import { ChevronRight } from 'lucide-react';
import { useOfferTimer } from '@/features/payments/hooks/use-offer-timer';
import unlockIcon from '../assets/icon-unlock.svg';
import { OfferStepper } from './offer-stepper';

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

function OfferCountdown() {
  const { minutes, seconds } = useOfferTimer();
  return (
    <div className="flex items-center gap-1">
      <TimeBlock value={pad(minutes)} unit="min" />
      <span className="flex h-[31px] w-[3px] items-center justify-center text-lg font-bold leading-none text-mf-neutral-900">
        :
      </span>
      <TimeBlock value={pad(seconds)} unit="sec" />
    </div>
  );
}

function TimeBlock({ value, unit }: { value: string; unit: string }) {
  return (
    <div className="flex w-12 flex-col items-center rounded-lg bg-mf-neutral-50 py-1">
      <span className="font-display text-xl font-bold leading-6 text-mf-neutral-900">{value}</span>
      <span className="font-body text-xs leading-4 text-mf-neutral-400">{unit}</span>
    </div>
  );
}

interface OfferStepperHeaderProps {
  offerLabels: string[];
  currentIndex: number;
  unlockedLabel?: string;
  onSkip?: () => void;
}

export function OfferStepperHeader({
  offerLabels,
  currentIndex,
  unlockedLabel,
  onSkip,
}: OfferStepperHeaderProps) {
  const showChrome = Boolean(onSkip) || Boolean(unlockedLabel);

  return (
    <div className="flex flex-col bg-white">
      {showChrome && (
        <div className="flex h-[60px] items-center justify-between bg-white px-4 shadow-[0_0_8px_rgba(26,22,19,0.03)]">
          {onSkip ? <OfferCountdown /> : <span />}
          {onSkip && (
            <button
              type="button"
              onClick={onSkip}
              className="flex h-10 items-center justify-center gap-2 rounded-full bg-mf-neutral-50 pl-3 pr-2"
            >
              <span className="font-body text-sm font-bold leading-4 text-mf-neutral-900">Skip</span>
              <ChevronRight className="size-5 text-mf-neutral-900" strokeWidth={2} />
            </button>
          )}
        </div>
      )}

      <OfferStepper offerLabels={offerLabels} currentIndex={currentIndex} />

      {unlockedLabel && (
        <div className="flex h-10 items-center justify-center gap-2 bg-mf-green px-5">
          <img src={unlockIcon} alt="" className="h-5 w-[18px]" />
          <span className="font-body text-sm font-bold leading-4 text-white">{unlockedLabel}</span>
        </div>
      )}
    </div>
  );
}
